import service from "./request";

/*
* post请求
* */
export function postAction(url, parameter) {
  return service({
    url,
    method: 'post',
    data: parameter
  });
}

/*
* get请求
* */
export function getAction(url, parameter) {
  return service({
    url,
    method: 'get',
    params: parameter
  });
}


/*
* put请求
* */
export function putAction(url, parameter) {
  return service({
    url,
    method: 'put',
    data: parameter
  });
}

/*
* delete请求
* */
export function deleteAction(url, parameter) {
  return service({
    url,
    method: 'delete',
    data: parameter
  });
}

/*
* 自定义请求
* */
export function httpAction(config) {
  return service({
    ...config,
  });
}
